import styled from "styled-components";
import "swiper/css";
import {SIZES} from "@/components/constants";
import {useSectionActive} from "@/app/[locale]/services/useSectionActive";
import DeliverySwiperContent from "@/app/[locale]/services/components/DeliverySwiperContent";

const DeliverySection = ({ data, index, activeIndex }) => {
    const slides = [data["service-pr1-pc1-img"], data["service-pr1-pc2-img"], data["service-pr1-pc3-img"]];
    const loopSlides = [...slides, ...slides, ...slides];

    const sectionActive = index <= activeIndex;
    const titleRefPc = useSectionActive(sectionActive);
    const titleRefMo = useSectionActive(sectionActive);
    const swipeRef = useSectionActive(sectionActive);
    return (
        <SectionWrap>
            <div className={"container"}>
                <div className={"title-wrap-pc"} ref={titleRefPc}>
                    <p className={"desc-text"} dangerouslySetInnerHTML={{__html: data["service-pr1-pc-title"]}}/>
                </div>

                <div className={"title-wrap-mo"} ref={titleRefMo}>
                    <p className={"desc-text"} dangerouslySetInnerHTML={{__html: data["service-pr1-mo-title"]}}/>
                </div>
                <div className={"swipe-area"} ref={swipeRef}>
                    <DeliverySwiperContent items={loopSlides}/>
                </div>
            </div>
        </SectionWrap>
    );
};
const SectionWrap = styled.section`
    padding: 80px 0;
    display: flex;
    flex-direction: column;
    gap: 120px;
    .title-wrap-pc,
    .title-wrap-mo,
    .swipe-area {
        opacity: 0;
        transform: translateY(60px);
        transition: all 0.6s ease;
    }
    .title-wrap-pc.is-show,
    .title-wrap-mo.is-show,
    .swipe-area.is-show  {
        opacity: 1;
        transform: translateY(0);
    }
    .container {
        width: 100%;
        margin: 0 auto;
        padding: 0 24px;

        .title-wrap-pc {
            display: none;
            margin-bottom: 64px;
            width: 100%;
            font-size: 40px;
            font-weight: 700;
            line-height: 0;

            p {
                line-height: 1.6;

                span {
                    color: #07903a;
                }
            }
        }

        .title-wrap-mo {
            display: block;
            margin-bottom: 32px;
            line-height: 0;
            font-weight: 700;
            font-size: 18px;

            p {
                line-height: 1.6;

                span {
                    color: #07903a;
                }
            }
        }

    }

    .pc {
        display: none;
    }

    .mo {
        display: block;
    }

    @media (min-width: ${SIZES.MOBILE}) {
        .container {
            max-width: 640px;
        }
    }

    @media (min-width: ${SIZES.MOBILE_L}) {
        .container {
            max-width: 768px;

            .hero-wrap {
                grid-template-columns: repeat(2, minmax(0, 1fr));
            }
        }

        .pc {
            display: block;
        }

        .mo {
            display: none;
        }
    }

    @media (min-width: ${SIZES.TABLET}) {
        gap: 133px;
        .container {
            max-width: 1024px;
            padding: 0 40px;

            .title-wrap-pc {
                display: block;
            }

            .title-wrap-mo {
                display: none;
            }
        }
    }

    @media (min-width: ${SIZES.TABLET_L}) {
        .container {
            max-width: 1280px;
        }
    }

    @media screen and (min-width: ${SIZES.PC}) {
        .container {
            max-width: 1536px;
        }
    }
`
export default DeliverySection;